import React from 'react';

import { CodeOutlined } from '@ant-design/icons';
import { Drawer, Input, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { TextArea } = Input;
const { Text } = Typography;

/**
 * HTMLEditorDrawer - HTML/Liquid Template Editor Drawer
 *
 * @param {Object} props
 * @param {boolean} props.visible - Whether drawer is visible
 * @param {Function} props.onClose - Close handler
 * @param {string} props.value - Template content value
 * @param {Function} props.onChange - Change handler
 */
export default function HTMLEditorDrawer({
  visible,
  onClose,
  value,
  onChange
}) {
  const { t } = useTranslation();

  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <Drawer
      title={
        <Space>
          <CodeOutlined style={{ color: '#1890ff' }} />
          <Text strong>{t('shared.order_templates.form.html_editor_title')}</Text>
        </Space>
      }
      placement="right"
      width={720}
      onClose={onClose}
      open={visible}
      styles={{ body: { padding: '16px' } }}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <div style={{
          padding: '12px',
          backgroundColor: '#fffbe6',
          border: '1px solid #ffe58f',
          borderRadius: '4px'
        }}>
          <Text type="secondary" style={{ fontSize: '13px' }}>
            {t('shared.order_templates.form.html_editor_hint')}
          </Text>
        </div>

        <TextArea
          value={value}
          onChange={handleChange}
          rows={30}
          placeholder={t('common.placeholder.please_enter')}
          style={{
            fontFamily: 'Monaco, Menlo, "Ubuntu Mono", "Courier New", monospace',
            fontSize: '13px',
            lineHeight: '1.6'
          }}
        />

        <div style={{
          padding: '12px',
          backgroundColor: '#f0f5ff',
          border: '1px solid #adc6ff',
          borderRadius: '4px'
        }}>
          <div style={{ marginBottom: '8px' }}>
            <Text strong style={{ fontSize: '13px', color: '#1890ff' }}>
              {t('shared.order_templates.form.liquid_filters_title')}
            </Text>
          </div>
          <Text type="secondary" style={{ fontSize: '12px', whiteSpace: 'pre-line' }}>
            {t('shared.order_templates.form.liquid_filters_hint')}
          </Text>
        </div>
      </Space>
    </Drawer>
  );
}
